import { Alert, Button } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';

export interface Props {
  id?: string;
  isConnected: boolean;
  buttonText?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

const AlertStatus: React.FC<React.PropsWithChildren<Props>> = ({ id, isConnected, buttonText, onClick }) => {
  const { translation } = useTranslation();
  return (
    <Alert
      id={id}
      variant="standard"
      severity={isConnected ? 'success' : 'error'}
      sx={{
        backgroundColor: isConnected ? 'rgba(102, 187, 106, 0.08)' : 'rgba(244, 67, 54, 0.08)',
        '& .MuiSvgIcon-root': {
          color: isConnected ? '#66BB6A' : '#F44336'
        },
        '& .MuiAlert-message': {
          color: isConnected ? '#CCE8CD' : '#F4C7C7',
          overflow: 'hidden',
          width: 'fit-content'
        },
        '& .MuiButton-label': {
          color: isConnected ? '#CCE8CD' : '#F4C7C7'
        },
        '& .MuiAlert-action': {
          padding: '4px 0 0 4px'
        }
      }}
      action={
        onClick ? (
          <Button size="small" variant="text" color="inherit" onClick={onClick} id={`${id}-resend-button`}>
            {buttonText}
          </Button>
        ) : undefined
      }
    >
      {isConnected ? translation.connected : translation.disconnected}
    </Alert>
  );
};

export default AlertStatus;
